<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import EmployeeBase from '../../../../../employees/components/EmployeeBase.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
    }
})
</script>

<template>
  <EmployeeBase />
</template>